;(function () {
  // tb-variant-picker

  // color variants
  if (document.querySelector(".variant-picker-color") !== null) {
    let initTooltips = function () {
      jQuery(".tb-tooltip-toggle").tooltip({
        position: {
          my: "center top+15",
          at: "center bottom",
          using: function (position, feedback) {
            $(this).css(position)
            $("<div>")
              .addClass("tb-tooltip")
              .addClass(feedback.vertical)
              .addClass(feedback.horizontal)
              .appendTo(this)
          },
        },
      })
    }
    let jqIntr = setInterval(function () {
      if (
        typeof jQuery === "function" &&
        typeof jQuery().tooltip === "function"
      ) {
        initTooltips()
        clearInterval(jqIntr)
      }
    }, 500)
  }

  // size variants
  if (document.querySelector(".variant-picker-size") !== null) {
    console.log("variant-picker-size")
    let syncHeadingUnitDisplay = function (scope, useCm) {
      if (!scope) return

      scope.querySelectorAll(".left_content_section h3 .in").forEach((el) => {
        el.style.display = useCm ? "none" : "contents"
      })
      scope.querySelectorAll(".left_content_section h3 .cm").forEach((el) => {
        el.style.display = useCm ? "contents" : "none"
      })
    }

    let syncUnitSwitchLabels = function (scope, useCm) {
      if (!scope) return

      scope.querySelectorAll(".size-switch .slider-label").forEach((el) => {
        el.classList.toggle(
          "active",
          el.classList.contains("slider-label-cm") === useCm,
        )
      })
    }

    let initPopup = function () {
      // open popup click
      document
        .querySelector(
          ".product-sizechart-wrapper .product-sizechart-popup-link",
        )
        .addEventListener("click", (event) => {
          event.preventDefault()
          // reset cm / in state
          let $toggler = jQuery(".product-sizechart-wrapper #sizeUnitsToggler")
          let $in = jQuery(
            ".product-sizechart-wrapper .product-sizechart-popup-content .in",
          )
          let $cm = jQuery(
            ".product-sizechart-wrapper .product-sizechart-popup-content .cm",
          )
          let useCm = $toggler.is(":checked")
          if (useCm) {
            $cm.show()
            $in.hide()
          } else {
            $in.show()
            $cm.hide()
          }
          let openPopupContent = document.querySelector(
            ".product-sizechart-wrapper .product-sizechart-popup-content",
          )
          syncHeadingUnitDisplay(openPopupContent, useCm)
          syncUnitSwitchLabels(openPopupContent, useCm)
          // show popup
          document
            .querySelector(
              ".product-sizechart-wrapper .product-sizechart-popup",
            )
            .classList.add("active")
          // prevent scrolling
          document.body.classList.add("overflow-hidden")
          // scroll to top of popup
          document.querySelector(".product-sizechart-popup-content").scrollTop =
            0
        })
      // close popup click
      document
        .querySelector(
          ".product-sizechart-wrapper .product-sizechart-popup-close",
        )
        .addEventListener("click", (event) => {
          document
            .querySelector(
              ".product-sizechart-wrapper .product-sizechart-popup",
            )
            .classList.remove("active")
          document.body.classList.remove("overflow-hidden")
          document
            .querySelector(".product-sizechart-wrapper #sizeUnitsForm")
            .reset()
        })
      // size units (in/cm) toggler
      document
        .querySelector(".product-sizechart-wrapper #sizeUnitsToggler")
        .addEventListener("click", (event) => {
          let $toggler = jQuery(event.target)
          let $in = jQuery(
            ".product-sizechart-wrapper .product-sizechart-popup-content .in",
          )
          let $cm = jQuery(
            ".product-sizechart-wrapper .product-sizechart-popup-content .cm",
          )
          let $cm_in = jQuery(
            ".product-sizechart-wrapper .product-sizechart-popup-content .cm:visible,.product-sizechart-wrapper .product-sizechart-popup-content .in:visible",
          ).not(".left_content_section h3 .cm,.left_content_section h3 .in")
          let popupContent = document.querySelector(
            ".product-sizechart-wrapper .product-sizechart-popup-content",
          )
          let useCm = $toggler.is(":checked")
          $in = $in.not(".left_content_section h3 .in")
          $cm = $cm.not(".left_content_section h3 .cm")
          syncHeadingUnitDisplay(popupContent, useCm)
          syncUnitSwitchLabels(popupContent, useCm)
          $cm_in.fadeOut(200, () => {
            if (useCm) {
              $cm.fadeIn(200)
            } else {
              $in.fadeIn(200)
            }
          })
        })
    }
    initPopup()
  }
})()
